(function () {
  const collectionData = JSON.parse(
    document.querySelector("script[collection-data]").innerHTML
  );
  // console.log('Collection Filters', collectionData);

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return removeProtocol(src);
    }

    const match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];

      return removeProtocol(`${prefix[0]}_${size}${suffix}`);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  const templates = {
    attributeFilter: document.querySelector("script[attribute-filter-template]")
      .innerHTML,
    filterItem: document.querySelector("script[filter-item-template]")
      .innerHTML,
    gridItem: document.querySelector("script[grid-item-template]").innerHTML,
    priceFilter: document.querySelector("script[filter-price-template]")
      .innerHTML,
    tagFilterItem: document.querySelector("script[tag-filter-item-template]")
      .innerHTML,
  };

  // Lib
  function getJsonFromUrl(url) {
    if (!url) {
      url = location.href;
    }
    const question = url.indexOf("?");
    let hash = url.indexOf("#");
    if (hash == -1 && question == -1) {
      return {};
    }
    if (hash == -1) {
      hash = url.length;
    }
    const query =
      question == -1 || hash == question + 1
        ? url.substring(hash)
        : url.substring(question + 1, hash);
    let result = {};
    query.split("&").forEach((part) => {
      if (!part) {
        return;
      }
      part = part.split("+").join(" "); // replace every + with space, regexp-free version
      const eq = part.indexOf("=");
      let key = eq > -1 ? part.substr(0, eq) : part;
      const val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : "";
      const from = key.indexOf("[");
      if (from == -1) {
        result[decodeURIComponent(key)] = val;
      } else {
        const to = key.indexOf("]", from);
        const index = decodeURIComponent(key.substring(from + 1, to));
        key = decodeURIComponent(key.substring(0, from));
        if (!result[key]) {
          result[key] = [];
        }
        if (!index) {
          result[key].push(val);
        } else {
          result[key][index] = val;
        }
      }
    });

    result = Object.keys(result).reduce((final, key) => {
      final[key] = result[key].split("|");

      return final;
    }, {});

    return result;
  }

  const filterUniqueBy = (arr, fn) =>
    arr.filter((v, i) => arr.some((x, j) => (i !== j) === fn(v, x, i, j)));

  const intersection = (a, b) => {
    const s = new Set(b);
    return [...new Set(a)].filter((x) => s.has(x));
  };
  // End of Lib
  let urlFilters = getJsonFromUrl();
  console.log(urlFilters);
  function itemIsKid(item) {
    return /kid's/gi.test(item.title);
  }

  function itemIsMen(item) {
    return /men's/gi.test(item.title);
  }

  function itemIsWoMen(item) {
    return /women's/gi.test(item.title);
  }

  Vue.directive("lazyload", {
    inserted: (el) => {
      function loadImage() {
        const imageElement = Array.from(el.children).find((el) =>
          el.classList.contains("pc-container")
        );

        // const bgSet = imageElement.getAttribute('data-bg');

        if (imageElement) {
          // imageElement.style.backgroundImage = bgSet;
          imageElement.classList.add("load");
          // imageElement.removeAttribute('data-bg');
        }
      }

      function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadImage();
            observer.unobserve(el);
          }
        });
      }

      function createObserver() {
        const options = {
          root: null,
          threshold: "0",
        };
        const observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(el);
      }
      if (window["IntersectionObserver"]) {
        createObserver();
      } else {
        loadImage();
      }
    },
  });

  Vue.component("attribute-filter", {
    template: templates.attributeFilter,
    props: {
      attribute: {
        required: true,
      },
      label: {
        required: false,
        default: "",
      },
      values: {
        required: false,
        default: [],
      },
    },
    data() {
      return {
        open: false,
        selected: [],
      };
    },
    watch: {},
    computed: {
      filterId() {
        return `filter-${this.label.replace(/\s+/g, "-").toLowerCase()}`;
      },
    },
    methods: {
      handlize(str) {
        return str.replace(/\s+/g, "-").toLowerCase();
      },
      onMouseEnter(event) {
        // console.log('Mouse Enter');
        this.open = !this.open;
        this.$emit("filteropened", this.label);
      },
      onMouseLeave(event) {
        // console.log('Mouse Leave');
        this.open = false;
      },
      onSelect(event) {
        const add = this.selected.includes(event.target.value);

        this.$emit("update", {
          add,
          value: event.target.value,
        });
      },
      resetFilters() {
        this.selected = [];
      },
    },
    mounted() {
      // console.log('Mount Attribute', this.values, this.selected, this.open, this.attribute, urlFilters, urlFilters[this.attribute]);

      if (urlFilters.attributes) {
        const applicableAttributes = [...urlFilters.attributes].filter(
          (attr) => {
            const [attribute, value] = attr.split(":");
            return attribute == this.attribute;
          }
        );

        // console.log('Applicable ATTR', applicableAttributes);
        this.selected = [...applicableAttributes];
      }
      this.$root.$on("clearFilters", this.resetFilters);

      this.$root.$on("siblingsopened", (label) => {
        if (label !== this.label) {
          this.open = false;
        }
      });
    },
  });

  Vue.component("grid-item", {
    template: templates.gridItem,
    props: {
      product: {
        required: true,
      },
    },
    data() {
      return {};
    },
    watch: {},
    computed: {
      percentageOff() {
        const cutPrice = this.product.price / 100 + 1.1 - 1.1;
        const cutSale = this.product.compare_at_price / 100;
        const decimal = (cutPrice / cutSale) * 100;
        const percentDiff = 100 - decimal;

        return percentDiff.toFixed();
      },
      onSale() {
        return this.product.compare_at_price > this.product.price;
      },
    },
    methods: {
      formatMoney(amount) {
        return window.Shopify.formatMoney(
          amount,
          window.Shopify.money_format || "${{amount}}"
        );
      },
      sizedImage(src, size = "x500") {
        return getSizedImageUrl(src, size);
      },
    },
    mounted() {
      // console.log('Mount Product', this.product);
    },
  });

  Vue.component("price-filter", {
    template: templates.priceFilter,
    props: {},
    data() {
      return {
        open: false,
        selected: null,
        label: "Price",
      };
    },
    watch: {},
    computed: {
      filterId() {
        return `filter-price`;
      },
    },
    methods: {
      itemClickHandler(event) {
        const $target = event.currentTarget;
        const $input = $target.querySelector("input");
        const isChecked = $input.checked;

        // console.log('Checked?', isChecked);
      },
      resetFilters() {
        this.selected = null;
      },
      onMouseEnter(event) {
        // console.log('Mouse Enter');
        this.open = !this.open;
        this.$emit("filteropened", this.label);
      },
      onMouseLeave(event) {
        // console.log('Mouse Leave');
        this.open = false;
      },
      onSelect(event) {
        const [min, max] = event.target.value.split(":");
        // console.log('Selected Price', event.target.value, min, max);

        this.$emit("update", {
          max: Number(max),
          min: Number(min),
        });
      },
    },
    mounted() {
      let defaultPrices = "";

      this.$root.$on("clearFilters", this.resetFilters);

      this.$root.$on("siblingsopened", (label) => {
        if (label !== this.label) {
          this.open = false;
        }
      });

      if (urlFilters.min) {
        defaultPrices += `${urlFilters.min == 0 ? "" : urlFilters.min}:`;

        if (urlFilters.max) {
          defaultPrices += `${urlFilters.max}`;
        }

        // console.log('Default Price 1', defaultPrices);
        this.selected = defaultPrices;
        return;
      }

      if (urlFilters.max) {
        if (urlFilters.min) {
          defaultPrices += `${urlFilters.min}`;
        }

        defaultPrices += `:${urlFilters.max}`;

        // console.log('Default Price 2', defaultPrices);
        this.selected = defaultPrices;
        return;
      }
    },
  });

  Vue.component("filter-item", {
    template: templates.filterItem,
    props: {
      label: {
        required: true,
      },
      type: {
        required: false,
      },
      flag: {
        required: false,
      },
      valueTags: {
        required: false,
        default: [],
      },
    },
    data() {
      return {
        open: false,
        selected: [],
        values: [],
      };
    },
    watch: {},
    computed: {
      filterId() {
        return `filter-${this.label.replace(/\s+/g, "-").toLowerCase()}`;
      },
    },
    methods: {
      handlize(str) {
        return str.replace(/\s+/g, "-").toLowerCase();
      },
      humanize(str) {
        const test = new RegExp("^" + this.flag, "i");
        const label = str.replace(test, "");

        return label
          .replace(/^[\s_]+|[\s_]+$/g, "")
          .replace(/[_\s]+/g, " ")
          .replace(/-/g, ".")
          .replace(/^[a-z]/, function (m) {
            return m.toUpperCase();
          });
      },
      onMouseEnter(event) {
        // console.log('Mouse Enter');
        this.open = !this.open;
        this.$emit("filteropened", this.label);
      },
      onMouseLeave(event) {
        // console.log('Mouse Leave');
        this.open = false;
      },
      onSelect(event) {
        const [category, value] = event.target.value.split(":");
        const add = this.selected.includes(event.target.value);

        // console.log('On Select', event.target, {
        //     add,
        //     category,
        //     value: event.target.value,
        // });

        this.$emit("update", {
          add,
          category,
          value: event.target.value,
        });
      },
      resetFilters() {
        this.selected = [];
      },
    },
    mounted() {
      const { flag, type } = this;

      if (urlFilters.sizes) {
        this.selected = [...urlFilters.sizes];
      }

      this.$root.$on("clearFilters", this.resetFilters);

      this.$root.$on("siblingsopened", (label) => {
        if (label !== this.label) {
          this.open = false;
        }
      });
    },
  });

  Vue.component("tag-filter-item", {
    template: templates.tagFilterItem,
    props: {
      label: {
        required: true,
      },
      type: {
        required: false,
      },
      flag: {
        required: false,
      },
      valueTags: {
        required: false,
        default: [],
      },
    },
    data() {
      return {
        open: false,
        selected: [],
        values: [],
      };
    },
    watch: {},
    computed: {
      filterId() {
        return `filter-${this.label.replace(/\s+/g, "-").toLowerCase()}`;
      },
    },
    methods: {
      handlize(str) {
        return str.replace(/\s+/g, "-").toLowerCase();
      },
      humanize(str) {
        const test = new RegExp("^" + this.flag, "i");
        const label = str.replace(test, "");

        return label
          .replace(/^[\s_]+|[\s_]+$/g, "")
          .replace(/[_\s]+/g, " ")
          .replace(/-/g, ".")
          .replace(/^[a-z]/, function (m) {
            return m.toUpperCase();
          });
      },
      onMouseEnter(event) {
        // console.log('Mouse Enter');
        this.open = !this.open;
        this.$emit("filteropened", this.label);
      },
      onMouseLeave(event) {
        // console.log('Mouse Leave');
        this.open = false;
      },
      onSelect(event) {
        const add = this.selected.includes(event.target.value);

        // console.log('Toggle Select', event.target.value ,add);

        this.$emit("update", {
          add,
          value: event.target.value,
        });
      },
      resetFilters() {
        this.selected = [];
      },
    },
    mounted() {
      const { flag, type } = this;

      this.$root.$on("clearFilters", this.resetFilters);
      const defaultTags = urlFilters["tags"];
      if (defaultTags) {
        const test = new RegExp(flag, "i");
        const applicableDefaultTags = [...defaultTags].filter((tag) => {
          return test.test(tag);
        });

        this.selected = [...applicableDefaultTags];
      }

      this.$root.$on("siblingsopened", (label) => {
        if (label !== this.label) {
          this.open = false;
        }
      });
    },
  });

  let defaultFilters = {
    attributes: [],
    sizes: [],
    price: {
      max: null,
      min: null,
    },
    tags: [],
  };

  Object.keys(urlFilters).forEach((key) => {
    if (key == "min" || key == "max") {
      defaultFilters["price"][key] = urlFilters[key];
      return;
    }

    defaultFilters[key] = urlFilters[key];
    // console.log('URL FILTER?', key);
  });
  // console.log('URL TO FILTERS', getJsonFromUrl(), defaultFilters);

  var collectionApp = new Vue({
    el: "#collection-page",
    data: {
      message: "Hello Vue!",
      products: [...collectionData.products],
      filters: { ...defaultFilters },
    },
    computed: {
      items() {
        return this.products;
      },
      sizeTags() {
        const sizes = [...this.products].reduce(
          function (tags, product) {
            const { options } = product;

            const sizeOption = options.findIndex(function (option) {
              return /size/i.test(option);
            });

            if (!sizeOption || sizeOption === -1) {
              return tags;
            }

            const allProductSizes = product.variants.map(function (variant) {
              return variant[`option${sizeOption + 1}`];
            });

            const productSizes = [...new Set(allProductSizes)];

            const isKid = /kid's/gi.test(product.title);
            const isWoMen = /women's/gi.test(product.title);
            const isMen = /men's/gi.test(product.title);
            const productSizeTags = product.tags.filter(function (tag) {
              return /^size-/i.test(tag);
            });
            if (isKid) {
              tags.kids = [...new Set(tags.kids.concat(productSizes))];
            } else if (isWoMen) {
              tags.womens = [...new Set(tags.womens.concat(productSizes))];
            } else if (isMen) {
              tags.mens = [...new Set(tags.mens.concat(productSizes))];
            } else {
              tags.adults = [...new Set(tags.adults.concat(productSizes))];
            }

            return tags;
          },
          { kids: [], womens: [], mens: [], adults: [] }
        );

        const sortedSizes = {
          kids: sizes.kids.sort((a, b) => Number(b) - Number(a)).reverse(),
          womens: sizes.womens.sort((a, b) => Number(b) - Number(a)).reverse(),
          mens: sizes.mens.sort((a, b) => Number(b) - Number(a)).reverse(),
          adults: sizes.adults.sort((a, b) => Number(b) - Number(a)).reverse(),
        };

        return sortedSizes;
      },
    },
    methods: {
      attributeFilterUpdate({ add, value }) {
        let currentAttributes = this.filters.attributes;

        if (add) {
          currentAttributes.push(value);
        } else {
          currentAttributes = currentAttributes.filter(function (size) {
            return size !== value;
          });
        }

        this.filters.attributes = [...currentAttributes];

        // console.log('Update Attributes');
      },
      doesItemQualify(item) {
        const isQualifiedByAttributes = this.qualifyByAttribute(item);
        const isQualifiedBySize = this.qualifyBySize(item);
        const isQualifiedByPrice = this.qualifyByPrice(item);
        const isQualifiedByTags = this.qualifyByTags(item);

        return (
          isQualifiedBySize &&
          isQualifiedByPrice &&
          isQualifiedByAttributes &&
          isQualifiedByTags
        );
      },
      handleFilterOpen(label) {
        // console.log('Filter Opened', label);

        this.$emit("siblingsopened", label);
      },
      async fetchAllProducts() {
        const pages = Math.ceil(collectionData.products_count / 100);
        let products = [];
        let current = 0;

        while (current < pages) {
          let pageOfProducts = await this.fetchPage(current + 1);

          products = products.concat(pageOfProducts);
          current++;
        }

        const withCurrent = this.products.concat(products);
        const seen = new Set();
        const noDuplicates = withCurrent.filter(function (item) {
          const duplicate = seen.has(item.id);
          seen.add(item.id);

          return !duplicate;
        });

        // console.log('Products', { pages, collectionData, noDuplicates, products: this.products });

        this.products = [...noDuplicates].map(function (item) {
          return {
            ...item,
            show: true,
          };
        });

        return true;
      },
      fetchPage(page = 1) {
        return fetch(
          `/collections/${collectionData.handle}?view=data&page=${page}`
        )
          .then(function (res) {
            return res.json();
          })
          .catch(function () {
            return null;
          });
      },
      filtersToUrl() {
        const filterKeys = Object.keys(this.filters);

        const activeFilters = [...filterKeys].reduce((actives, key) => {
          const values = this.filters[key];
          if (key === "price") {
            const price = this.filters[key];
            if (!price.min && !price.max) return actives;

            actives["min"] = price.min;
            actives["max"] = price.max;

            // console.log('Returning', actives);

            return actives;
          }
          if (values.length === 0) return actives;

          // console.log('Active Filters', key, values);

          actives[key] = [...values];

          return actives;
        }, {});

        // console.log('Actives as Obj', activeFilters);

        const asParameters = [...Object.keys(activeFilters)].map((key) => {
          let values = this.filters[key];

          if (key === "min" || key === "max") {
            values = activeFilters[key];
          }
          // console.log('Run', key, values);
          return Array.isArray(values)
            ? `${key}=${values.join("|")}`
            : `${key}=${values}`;
        });

        return `?${asParameters.join("&")}`;
      },
      priceFilterUpdate({ min, max }) {
        if (min == 0 && max == 0) {
          min = null;
          max = null;
        }

        this.filters.price = {
          min,
          max,
        };
      },
      productAttributes(attribute) {
        const allAttributes = this.products.map(function (product) {
          return product[attribute];
        });

        return [...new Set(allAttributes)];
      },
      productTags(flagExp) {
        const tags = [...this.products].reduce(function (tags, product) {
          const qualifyTags = product.tags.filter(function (tag) {
            return flagExp.test(tag);
          });

          tags = [...new Set([...tags, ...qualifyTags])];

          return tags;
        }, []);

        return tags;
      },
      qualifyByAttribute(item) {
        const attributeFilters = this.filters.attributes;

        // If no active filters, everything qualifies
        if (attributeFilters.length === 0) return true;

        const attributeValues = [...attributeFilters].reduce(function (
          attributes,
          filter
        ) {
          const [attribute, value] = filter.split(":");

          attributes[attribute] = attributes[attribute] || [];

          attributes[attribute].push(value);

          return attributes;
        },
        {});

        const attributesQualify = Object.keys(attributeValues).every(function (
          attribute
        ) {
          const values = attributeValues[attribute];

          return values.includes(item[attribute]);
        });

        return attributesQualify;
      },
      qualifyByPrice(item) {
        // If no min/max set, everything qualifies by price.
        if (!this.filters.price.min && !this.filters.price.max) return true;

        const { min, max } = this.filters.price;

        const { price } = item;

        // If min & if max, qualify individually.
        return (min ? min <= price : true) && (max ? price <= max : true);
      },
      qualifyBySize(item) {
        const isKid = itemIsKid(item);
        const isWoMen = itemIsWoMen(item);
        const isMen = itemIsMen(item);
        const activeSizes = this.filters.sizes;
        const categorySizes = [...activeSizes].filter(function (sizeTag) {
          if (isKid) {
            var return_tag = /kid:/.test(sizeTag);
          } else if (isWoMen) {
            var return_tag = /women:/.test(sizeTag);
          } else if (isMen) {
            var return_tag = /men:/.test(sizeTag);
          }
          return return_tag;
          //return isKid ? /kid:/.test(sizeTag) : /adult:/.test(sizeTag);
        });

        // If no sizes are chosen ( either category ) then everything passes the size filters.
        if (activeSizes.length === 0) return true;

        // If sizes are chosen, but none for this category then this product fails the size filters.
        if (categorySizes.length === 0) return false;

        const { options } = item;

        const sizeOption = options.findIndex(function (option) {
          return /size/i.test(option);
        });

        // This item doesn't have a SIZE option so it fails the size filters.
        if (!sizeOption || sizeOption === -1) {
          return false;
        }

        const sizes = categorySizes.map(function (value) {
          return value.split(":").reverse()[0];
        });

        const variantWithSize = item.variants.find(function (variant) {
          return sizes.includes(variant[`option${sizeOption + 1}`]);
        });

        return Boolean(variantWithSize);
      },
      qualifyByTags(item) {
        // if no tags active, everything passes.
        if (this.filters.tags.length === 0) return true;

        return intersection(this.filters.tags, item.tags).length > 0;
      },
      resetFilters() {
        this.filters = {
          attributes: [],
          sizes: [],
          price: {
            max: null,
            min: null,
          },
          tags: [],
        };

        this.$emit("clearFilters");
      },
      sizeFilterUpdate({ add, category = "all", value }) {
        const currentSizes = this.filters["sizes"];
        let currentCategorySizes = currentSizes || [];

        if (add) {
          currentCategorySizes.push(value);
        } else {
          currentCategorySizes = currentCategorySizes.filter(function (size) {
            return size !== value;
          });
        }

        this.filters["sizes"] = [...currentCategorySizes];
      },
      tagFilterUpdate({ add, value }) {
        const currentTags = this.filters["tags"];
        let currentCategoryTags = currentTags || [];

        if (add) {
          currentCategoryTags.push(value);
        } else {
          currentCategoryTags = currentCategoryTags.filter(function (tag) {
            return tag !== value;
          });
        }

        this.filters["tags"] = [...currentCategoryTags];
      },
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          const asUrl = this.filtersToUrl();

          window.history.pushState({}, null, asUrl);

          // console.log('Filters Changed', this.filters, asUrl);

          const newItems = this.products.map((item) => {
            const show = this.doesItemQualify(item);

            return {
              ...item,
              show,
            };
          });

          this.products = newItems;
        },
      },
    },
    async mounted() {
      this.products = [...this.products].map((item) => {
        const show = this.doesItemQualify(item);

        return {
          ...item,
          show,
        };
      });

      const product = await this.fetchAllProducts();

      const newItems = this.products.map((item) => {
        const show = this.doesItemQualify(item);

        return {
          ...item,
          show,
        };
      });

      this.products = [...newItems];
    },
  });
})();
